module.exports = __webpack_public_path__ + "static/net.e4450fa5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Pristop/images/net.svg
// module id = 783
// module chunks = 35783957827783